// src/themes/index.js
// Import base theme first
import '../styles/themes/ThemeBase.css';  // Add this if you've created ThemeBase.css

// Import theme-specific CSS files
import '../styles/themes/ClassicTheme.css';
import '../styles/themes/ClassicSqTheme.css';
import '../styles/themes/FaceTheme.css';
import '../styles/themes/DotsTheme.css';
import '../styles/themes/WavesTheme.css';
import '../styles/themes/IceTheme.css';
import '../styles/themes/GrungeTheme.css';
import '../styles/themes/ArtTheme.css';
import '../styles/themes/VinylTheme.css';
import '../styles/themes/MonitorsTheme.css';
import '../styles/themes/YellowTheme.css';
import '../styles/themes/LeafTheme.css';
import '../styles/themes/HeartsTheme.css';
import '../styles/themes/GrafTheme.css';

export const themeList = [
  {
    id: 'face',
    name: 'Face',
    description: 'Graffiti Face. \n\nRemember to choose a contrasting text color in details editor for this theme.',
    preview: '/theme-previews/face.jpg',
    tier: 'free'  // Add tier for categorization
  },
  {
    id: 'classic',
    name: 'Classic Round',
    description: 'A clean layout with round edges utilising the palatte colors. \n\nRemember to choose a contrasting text color in details editor for this theme.',
    preview: '/theme-previews/classicro.jpg',
    tier: 'free'  // Add tier for categorization
  },
  {
    id: 'classicsq',
    name: 'Classic Square',
    description: 'A clean layout with square edges utilising the palatte colors. \n\nRemember to choose a contrasting text color in details editor for this theme.',
    preview: '/theme-previews/classicsq.jpg',
    tier: 'free'  // Add tier for categorization
  },
  {
    id: 'hearts',
    name: 'Hearts',
    description: 'Theme of hearts. \n\nRemember to choose a contrasting text color in details editor for this theme.',
    preview: '/theme-previews/hearts.jpg',
    tier: 'free'  // Add tier for categorization
  },
  {
    id: 'dots',
    name: 'Dots',
    description: 'A fun colorful layout. \n\nRemember to choose a contrasting text color in details editor for this theme.',
    preview: `/theme-previews/dots.jpeg`,
    tier: 'free'  // Add tier for categorization
  },
  {
    id: 'graf',
    name: 'Graf',
    description: 'A graf themed layout. \n\nRemember to choose a contrasting text color in details editor for this theme.',
    preview: `/theme-previews/graf.jpg`,
    tier: 'free'  // Add tier for categorization
  },
  {
    id: 'waves',
    name: 'Waves',
    description: 'A social layout with blue and yellow tones. \n\nRemember to choose a contrasting text color in details editor for this theme.',
    preview: '/theme-previews/waves.jpg',
    tier: 'free'  // Add tier for categorization
  },
  {
    id: 'ice',
    name: 'Ice',
    description: 'A cool, clear theme with a blue feel. \n\nRemember to choose a contrasting text color in details editor for this theme.',
    preview: '/theme-previews/ice.jpg',
    tier: 'free'  // Add tier for categorization
  },
  {
    id: 'grunge',
    name: 'Grunge',
    description: 'Grimy grungy style. \n\nRemember to choose a contrasting text color in details editor for this theme.',
    preview: '/theme-previews/grunge.jpg',
    tier: 'free'  // Add tier for categorization
  },
  {
    id: 'art',
    name: 'Art',
    description: 'Artists style. \n\nRemember to choose a contrasting text color in details editor for this theme.',
    preview: '/theme-previews/art.jpg',
    tier: 'free'  // Add tier for categorization
  },
  {
    id: 'vinyl',
    name: 'Vinyl',
    description: 'Vinyl records. \n\nRemember to choose a contrasting text color in details editor for this theme.',
    preview: '/theme-previews/vinyl.jpg',
    tier: 'free'  // Add tier for categorization
  },
  {
    id: 'monitors',
    name: 'Monitors',
    description: 'Wall of monitors. \n\nRemember to choose a contrasting text color in details editor for this theme.',
    preview: '/theme-previews/monitors.jpg',
    tier: 'free'  // Add tier for categorization
  },
  {
    id: 'yellow',
    name: 'Yellow',
    description: 'Calm mellow yellow. \n\nRemember to choose a contrasting text color in details editor for this theme.',
    preview: '/theme-previews/yellow.jpg',
    tier: 'free'  // Add tier for categorization
  },
  {
    id: 'leaf',
    name: 'Leaf',
    description: 'Leaf in the rain. \n\nRemember to choose a contrasting text color in details editor for this theme.',
    preview: '/theme-previews/leaf.jpg',
    tier: 'free'  // Add tier for categorization
  },
 
];

// Helper function to get theme by ID
export const getThemeById = (themeId) => {
  return themeList.find(theme => theme.id === themeId) || themeList[0];
};

// Function to apply a theme
export const applyTheme = (themeId) => {
  // Get the theme object
  const theme = getThemeById(themeId);
  
  if (!theme) {
    console.error(`Theme '${themeId}' not found`);
    return null;
  }
  
  try {
    // Remove any existing theme classes from both body and root elements
    themeList.forEach(t => {
      document.body.classList.remove(`theme-${t.id}`);
      document.documentElement.classList.remove(`theme-${t.id}`);
    });
    
    // Add the new theme class to both body and root for better CSS cascade handling
    document.body.classList.add(`theme-${theme.id}`);
    document.documentElement.classList.add(`theme-${theme.id}`);
    
    // Store the current theme in localStorage for persistence
    localStorage.setItem('currentTheme', theme.id);
    
    console.log(`Theme '${theme.name}' applied successfully`);
    return theme;
  } catch (error) {
    console.error(`Error applying theme '${themeId}':`, error);
    return null;
  }
};

// Apply the default theme on module import (if none is stored)
const storedTheme = localStorage.getItem('currentTheme');
if (storedTheme) {
  // Use a timeout to ensure DOM is ready
  setTimeout(() => {
    applyTheme(storedTheme);
  }, 0);
} else {
  // Apply default theme
  setTimeout(() => {
    applyTheme('classic');
  }, 0);
}